import ReactDOM from "react-dom";

export default function Tooltip({ children, position }) {
  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed", // NOT absolute
        top: position.y,
        left: position.x,
        backgroundColor: "#111",
        color: "white",
        padding: "10px 16px",
        borderRadius: "8px",
        fontSize: "14px",
        zIndex: 9999,
        maxWidth: "300px",
        pointerEvents: "auto", // important for hover!
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
      }}
      onMouseEnter={position.onMouseEnter}
      onMouseLeave={position.onMouseLeave}
    >
      {children}
    </div>,
    document.getElementById("tooltip-root")
  );
}
